<template>
  <b-modal
    id="modal-re-enrollment-eligibility"
    ok-title="Save"
    centered
    size="md"
    title="Re-Enrollment Eligibility"
    :visible="isOpen"
    @show="reset"
    @hidden="() => $emit('update:is-open', false)"
    @ok="submit"
  >
    <b-form-group label="Re-Enrollment Eligible" label-for="re-enrollment-eligibility">
      <v-select
        id="re-enrollment-eligibility"
        v-model="eligibility"
        :options="reEnrollmentEligibilityOptions"
        :reduce="(val) => val.value"
        placeholder="Not set"
      />
    </b-form-group>
    <b-form-group label="Note" label-for="re-enrollment-note" description="Why this determination was made">
      <b-form-textarea id="re-enrollment-note" v-model="note" rows="3" :disabled="!eligibility" />
    </b-form-group>
  </b-modal>
</template>

<script>
import { BFormGroup, BFormTextarea, BModal } from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import { reEnrollmentEligibilityOptions } from '@/views/apps/roster/profile/profileOptions';

export default {
  components: { BFormGroup, BFormTextarea, BModal, vSelect },
  props: {
    isOpen: { type: Boolean },
    studentData: { type: Object, required: true },
    profileData: { type: Object, required: true },
  },
  data() {
    return { eligibility: null, note: '', reEnrollmentEligibilityOptions };
  },
  methods: {
    reset() {
      const current = this.profileData.reEnrollment || {};
      this.eligibility = current.eligibility || null;
      this.note = current.note || '';
    },
    submit() {
      const current = this.profileData.reEnrollment || {};
      const eligibility = this.eligibility || null;
      // The date marks when the determination was made, so a note edit keeps it.
      let timestamp = null;
      if (eligibility) timestamp = eligibility === current.eligibility && current.timestamp ? current.timestamp : new Date();

      this.$store
        .dispatch('studentStoreModule/updateStudentProfile', {
          id: this.studentData.id,
          profileData: { reEnrollment: { eligibility, note: eligibility ? this.note : '', timestamp } },
        })
        .then(() => {
          this.$emit('update:is-open', false);
          this.$emit('refetch-data');
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Failed to update re-enrollment eligibility', icon: 'AlertTriangleIcon', variant: 'danger' },
          });
        });
    },
  },
};
</script>
